/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/ScimConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ScimConfigCardTestIds = {
  btnCreateScimConfig: "btn-create-scim-config",
  btnEditScimConfig: "btn-edit-scim-config",
  cardTitleScimConfig: "card-title-scim-config",
  selectPatchStyle: "select-patch-style"
} as const;
